import React from 'react';
import { Alert } from 'react-bootstrap';

type UpdateRematerializeAlertProps = {
  warning: string | null;
  onDismiss: () => void;
};

/** Dismissible warning shown after PUT /node_instances when nested rematerialize was skipped. */
export function UpdateRematerializeAlert({ warning, onDismiss }: UpdateRematerializeAlertProps) {
  if (!warning) {
    return null;
  }

  return (
    <Alert variant="warning" onClose={onDismiss} dismissible>
      {warning}
    </Alert>
  );
}
